import { Loader } from './styles'

export function PageLoader() {
  return <Loader role="status" aria-label="Carregando página" />
}
